{
  "superwordNegative": [
    "Boost your score, mention [[word]] with confidence!",
    "Score big! Slip in [[word]] for an excellent call.",
    "Up your performance: use [[word]] for bonus points!",
    "Don't forget to use [[word]] for added flair!",
    "Score extra points! Add [[word]] to your conversations.",
    "Your secret weapon: [[word]] !",
    "Remember to slip in [[word]]!",
    "Maximize points, mention [[word]] in each conversation!",
    "Mentioning [[word]] is your key to surpassing expectations!",
    "Remember to include [[word]] in every call!"
  ],
  "superwordPositive": [
    "Congrats! You have been using [[word]] consistently!",
    "You are collecting many points from using [[word]]!",
    "Amazing work on using [[word]] in every conversation!",
    "Great work on using [[word]]!",
    "Nice job! You added value to a conversation with [[word]]!",
    "Nice job! You surpassed expectations when using [[word]]!",
    "Well done! You scored extra points with [[word]]!",
    "Well done! You collected tons of points from using [[word]]!",
    "Amazing job on incorporating [[word]] in conversations!",
    "Consistent work on using [[word]]! Keep it up!"
  ],
  "dontSayWordNegative": [
    "Avoid [[word]] for optimal call outcomes.",
    "Omit [[word]] for better call results.",
    "Exclude [[word]] for better call performance.",
    "Steer clear of [[word]] in each conversation.",
    "Eliminate [[word]] for a positive impact.",
    "Leave out [[word]], keep it positive!",
    "Friendly tip: Drop [[word]] for a positive call.",
    "Exclude [[word]] for call success.",
    "Skip [[word]] to enhance your performance.",
    "Up your game: No [[word]] for success"
  ],
  "dontSayWordPositive": [
    "Congrats! You steered clear of \"don't say\" words!",
    "Nice work! \"don't say\" words were rarely mentioned!",
    "Great job! You used \"don't say\" words at a minimum!",
    "Nicely done! You used \"don't say\" words at a minimum!",
    "Excellent! You used \"don't say\" words at a minimum!",
    "The conversations went smoothly without \"don't say\" words!",
    "Nice work! You made sure to mention less \"don't say\" words!",
    "You used \"don't say\" words at a minimum! Keep it up!",
    "You met expectations with using less \"don't say\" words!",
    "Awesome jon! Not many \"don't say\" words were mentioned!"
  ],
  "speechMetricsPaceTooFast": [
    "Influence call success positively by speaking a little slower!",
    "Slower speech for successful call results.",
    "Slow down to ensure a positive conversation flow.",
    "A slower pace ensures better results.",
    "Slow down for clearer, more effective calls"
  ],
  "speechMetricsPaceTooSlow": [
    "Control the pace: Slower speech for successful call results.",
    "Increase pace for dynamic, effective conversations.",
    "A quicker pace improves call interactions.",
    "Speak a little faster for impactful conversations.",
    "Increase speed for clearer, more effective calls."
  ],
  "speechMetricsPacePositive": [
    "Nice work! Your speech pace is perfect!",
    "Amazing! You speak wtih such perfect pace!",
    "Your speech speed is just right! Keep it up!",
    "Your speech speed is perfect! Keep it up!",
    "You controlled the speed perfectly!"
  ],
  "doSayWordNegative": [
    "Include [[word]] for optimal call outcomes.",
    "Remember to include [[word]] for better call results.",
    "Try to include [[word]] for better call performance.",
    "Stick with [[word]] in each conversation.",
    "Stick with [[word]] for a positive impact.",
    "Make sure to mention [[word]], keep it positive!",
    "Friendly tip: Use [[word]] for a positive call.",
    "Attention! Use [[word]] for call success.",
    "Using [[word]] could enhance your performance.",
    "Up your game: Use [[word]] for success!"
  ],
  "doSayWordPositive": [
    "Congrats! You stick with \"do say\" words very often!",
    "Nice work! \"do say\" words were often mentioned!",
    "Great job! You made use of many \"do say\" words!",
    "Nicely done! You usually mentioned \"do say\" words",
    "Excellent work! You usually mentioned \"do say\" words"
  ]
}